// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cc_h","col":"styles_col__3kNou"};